import { adequacySkipLinkText } from "i18n/messages/buttonTitles";
import PrevButton from "components/PrevButton";
import NextButton from "components/NextButton";
import { HIGHEST_EDUCATION_DATA } from "constants/index";
import { useSideModalScrollToTop } from "hooks";

const HighestEducation = ({
    backSlideEffect = "",
    setBackSlideEffect,
    formData,
    setFormData,
    setAdequacyStart,
    adequacyData,
    formatMessage,
    messages,
    labelIDPrefix,
    open,
    // setPreviousStep,
    StatusAdequacy,
}) => {
    useSideModalScrollToTop();

    return (
        <>
            <div className={`highest-education multisteps ${backSlideEffect}`}>
                <div className="header-part">
                    <h4 className="primary-color">{formatMessage(messages.educationHeading)}</h4>
                </div>
                <div className="content">
                    <form
                        method="post"
                        id={labelIDPrefix ? `${labelIDPrefix}_highest_education` : "highest_education"}
                        className="survey-form"
                    >
                        <h3 className="mt-4 mb-7">{formatMessage(messages.educationQuestion)}</h3>
                        <div className="tabs">
                            {HIGHEST_EDUCATION_DATA().map((item, index) => {
                                return (
                                    <div key={index}>
                                        <input
                                            onChange={({ target: { value: TypeEducation } }) =>
                                                setFormData((prevState) => ({ ...prevState, TypeEducation }))
                                            }
                                            value={item.value}
                                            id={labelIDPrefix ? `${labelIDPrefix}_${item.value}` : item.value}
                                            type="radio"
                                            name="education-question"
                                            checked={item.value === formData?.TypeEducation}
                                        />
                                        <label htmlFor={labelIDPrefix ? `${labelIDPrefix}_${item.value}` : item.value}>
                                            {item.label}
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                    </form>
                </div>
                {StatusAdequacy != "renew" && (
                    <span
                        onClick={() => {
                            setAdequacyStart({ step: 2 });
                            setBackSlideEffect("step-slide-right");
                        }}
                        className="skip-link"
                    >
                        {formatMessage(adequacySkipLinkText)}
                    </span>
                )}
            </div>
            {open && (
                <div className="bottom-bar-container">
                    <PrevButton
                        onClick={() => {
                            setBackSlideEffect("step-slide-right");
                            setAdequacyStart({
                                step: 4,
                                survey_first_step: {
                                    ...adequacyData.survey_first_step,
                                    step: 1,
                                },
                            });
                        }}
                    />
                    <NextButton
                        className={`${formData?.TypeJob && formData?.TypeEducation ? "" : "disable-grey"}`}
                        onClick={() => {
                            setBackSlideEffect("step-slide-left");
                            formData?.TypeJob &&
                                formData?.TypeEducation &&
                                setAdequacyStart({
                                    step: 5,
                                    survey_first_step: {
                                        ...adequacyData.survey_first_step,
                                        ...formData,
                                        step: 2,
                                    },
                                });
                        }}
                    />
                </div>
            )}
        </>
    );
};

export default HighestEducation;
